import React from 'react'

interface ConfigErrorProps {
  error: string
}

const ConfigError: React.FC<ConfigErrorProps> = ({ error }) => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <div className="mx-auto h-12 w-12 flex items-center justify-center rounded-full bg-red-100">
            <svg className="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          </div>
          <h2 className="mt-6 text-3xl font-extrabold text-gray-900">
            Configuration Error
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            {error}
          </p>
          <div className="mt-6 p-4 bg-yellow-50 border-l-4 border-yellow-400">
            <div className="text-sm text-yellow-700">
              <p className="font-medium">To fix this issue:</p>
              <ol className="mt-2 list-decimal list-inside space-y-1">
                <li>Go to your Vercel dashboard</li>
                <li>Navigate to your project settings</li>
                <li>Add these environment variables:
                  <ul className="mt-1 ml-4 list-disc list-inside text-xs">
                    <li>REACT_APP_SUPABASE_URL</li>
                    <li>REACT_APP_SUPABASE_ANON_KEY</li>
                  </ul>
                </li>
                <li>Redeploy your application</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ConfigError